<template>
    <div>    
        <el-form ref="form" :model="question_info" class="main_form" v-if="question_info.length > 0">
            <template v-for="(item, index) in question_info">
                <div :key="item.id" class="main_form_div">
                    <el-form-item :label="item.category" class="main_form_category"></el-form-item>
                    <div :key="index" class="sub_category">
                        <template v-for="sj in item.subject">
                            <div :key="sj.subject_desc_main">
                                <el-form-item label="" class="subject_info">
                                    <span slot="label" v-if="sj.low_score_error || sj.continuous_error">
                                        <span style="color:red;">*</span>
                                        <span style="color:red;margin-left:5px;">
                                            <span>{{ sj.subject_desc_main }}</span> ：{{ sj.subject_desc_sub }}
                                        </span>
                                    </span>
                                    <span slot="label" v-else-if="!sj.selected_option && error_flag">
                                        <span style="color:red;">*</span>
                                        <span style="color:red;margin-left:5px;">
                                            <span>{{ sj.subject_desc_main }}</span> ：{{ sj.subject_desc_sub }}
                                        </span>
                                    </span>
                                    <span slot="label" v-else-if="(sj.selected_option && error_flag) || !error_flag">
                                        <span style="color:red;">*</span>
                                        <span style="margin-left:5px;">
                                            <span>{{ sj.subject_desc_main }}</span> ：{{ sj.subject_desc_sub }}
                                        </span>
                                    </span>
                                </el-form-item>
                                <div class="option_info">
                                    <!-- <template v-for="(option, index) in sj.options">  
                                        <el-radio :key="index" v-model="sj.selected_option" :label="option" v-if="sj.low_score_error || sj.continuous_error" style="color:red;" class="option_error">{{ option }}</el-radio>
                                        <el-radio :key="index" v-model="sj.selected_option" :label="option" v-else-if="(!sj.selected_option && error_flag)" style="color:red;">{{ option }}</el-radio>
                                        <el-radio :key="index" v-model="sj.selected_option" :label="option" v-else-if="(sj.selected_option && error_flag) || (!error_flag)">{{ option }}</el-radio>
                                    </template> -->
                                    <el-radio-group v-model="sj.selected_option" @change="modify_radio">
                                        <template v-for="(option, index) in sj.options">  
                                            <el-radio :key="index" :label="option" :disabled="is_view" v-if="sj.low_score_error || sj.continuous_error" style="color:red;" class="option_error">{{ option }}</el-radio>
                                            <el-radio :key="index" :label="option" :disabled="is_view" v-else-if="(!sj.selected_option && error_flag)" style="color:red;">{{ option }}</el-radio>
                                            <el-radio :key="index" :label="option" :disabled="is_view" v-else-if="(sj.selected_option && error_flag) || (!error_flag)">{{ option }}</el-radio>
                                        </template>
                                    </el-radio-group>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
            <el-form-item label="举证说明" class="main_form_category"></el-form-item>
            <template v-for="item in proof_info">
                <div :key="item.proof_desc" class="proof_area">
                    <el-form-item :label="item.proof_desc"></el-form-item>
                    <el-input
                        type="textarea"
                        resize="none"
                        :placeholder="item.proof_default"
                        :rows="4"
                        v-model="item.proof"
                        :disabled="is_view">
                        <span slot="placeholder">{{ item.proof_default }}</span>
                    </el-input>
                </div>
            </template>
        </el-form>
        <!-- <div v-if="question_info.length <= 0" class="no_ques">暂无问卷信息，请先导入。</div> -->
        <div v-if="display_flag===true" class="no_ques" v-cloak>暂无组织健康度调研信息，请先导入。</div>
    </div>   
</template>

<script>
import postdata from "@/api/postData.js";
// import getdata from "@/api/getData.js";
export default {
    // 组件传递的prop数据，会在beforeUpdate钩子期间生效！
    beforeUpdate() {
        if(this.question_info.length <= 0){
            this.display_flag = true;
        }else{
            // 这里要增加else的处理，在导入模板后更新display_flag的值，因为没有重新加载页面，所以此时的display_flag不会从重置为初始值false开始判断
            this.display_flag = false;
        }
    },
    data() {
        return {
            template_file: {
                file_name: 'health-survey-import_template.xlsx'
            },
            formInline: {
                search_info: '',
                search_result: [],
            },
            display_flag: false,
        }
    },
    props: ['question_info', 'proof_info', 'error_flag', 'submit_times', 'is_view'],
    methods: {
        modify_radio() {
            if(this.submit_times > 0){
                this.$emit('sendData', [this.question_info, this.proof_info, 'modify_check']);  // 此处传递3个数据，用于和正常提交时的2个数据做区别
            }
        },
        Download_template() {
            postdata.downloadFiles("download", JSON.stringify(this.template_file))
              .then(resp => {
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                this.download(resp);
              })
              .catch(err => {
                console.log(err);
              })
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
        // 向父组件传递问卷测评结果（包括选择题和举证题两部分）
        submitManaQues() {
            // console.log('send data to father component.');
            this.$emit('sendData', [this.question_info, this.proof_info, 'normal']);
        },
        // 向父组件传递问卷测评结果（包括选择题和举证题两部分）---仅用于定时任务
        submitManaQues_timer() {
            // console.log('send data to father component.');
            this.$emit('sendData', [this.question_info, this.proof_info, 'timer']);
        },
        // 当连续值超限或3分及以下选项未达标时，更新对应的error状态，用于标红处理
        update_error_info(continuous_error_info, low_score_error_info) {
            var i = 0;
            var cg;
            var sj;
            for(cg in this.question_info){
                for(sj in this.question_info[cg]['subject']){
                    this.question_info[cg]['subject'][sj]['low_score_error'] = low_score_error_info[i];
                    this.question_info[cg]['subject'][sj]['continuous_error'] = continuous_error_info[i];
                    i = i + 1;
                }
            }
        },
    }
}
</script>

<style scoped>
[v-cloak]{
    display: none !important;
}
.dialog_form /deep/ .el-input {
    width: 223.67px;
}
::v-deep .el-form-item {
    margin-bottom: 0;
}
.main_form {
    padding: 20px;
    /* min-width: 1900px; */
}
.main_form_div {
    /* background: #f5f7fa; */
    margin-bottom: 25px;
}
.main_form_div /deep/ .el-form-item__label {
    font-size: 16px;
    line-height: 20px;
    /* color: #409EFF; */
}
.main_form_category {
    border-left: solid 4px #409EFF;
    padding-left: 15px;
    /* font-weight: bold;
    margin-bottom: 10px; */
    height: 20px;
    line-height: 20px;
}
.main_form_category /deep/ .el-form-item__label {
    font-size: 16px;
    line-height: 20px;
    /* color: #409EFF; */
}
.sub_category {
    border: 1.3px solid #cccccc;
    /* margin-bottom: 10px; */
    border-radius: 5px;
    margin-top: 17px;
    padding-bottom: 20px;
}
.sub_category_desc {
    text-align: left;
    /* margin-bottom: 10px;
    padding: 8px; */
    font-size: 14px;
    /* font-weight: bold; */
    color: #333333;
    background: #f8f8f8;
    border-bottom: 1.3px solid #cccccc;
    padding-left: 18px;
    padding-top: 10px;
    padding-bottom: 10px;
}
.subject_info {
    /* background: #cee4f1; */
    /* background: #f5f7fa; */
    /* opacity: 0.4; */
    padding-left: 18px;
    /* margin-bottom: 2px; */
    margin-top: 20px;
}
.subject_info /deep/ .el-form-item__label {
    /* width: 75%; */
    text-align: left;
    color: #606266;
    font-size: 14px;
    /* line-height: 40px; */
}
/* .subject_info /deep/ .el-form-item__content {
    width: 650px;
    float: right;
} */
.option_info {
    text-align: left;
    height: 35px;
    /* line-height: 35px; */
    margin-left: 20px;
    margin-right: 20px;
    border-bottom: 1px dashed #d9d9d9;
    margin-top: 5px;
}
.proof_area {
    border: 1px solid #cccccc;
    border-radius: 5px;
    padding: 10px 17px 17px 17px;
    margin-top: 17px;
}
.proof_area /deep/ .el-form-item__label {
    font-size: 14px;
    color: #606266;
}
.no_ques {
  width: 100%;
  margin: 0 auto;
  color: #909399;
  font-weight: bold;
  height: 60px;
  line-height: 60px;
  margin-top: 20px;
}
.option_error /deep/ .el-radio__input.is-checked+.el-radio__label {
    color: red;
}
.option_error /deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: red;
    background: red;
}
</style>